class LogoRow extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector(".logo-row__track");
    this.list = this.querySelector(".logo-row__list");
    /** @type {HTMLElement|null} */
    this.duplicateList = this.querySelector(
      '.logo-row__list[aria-hidden="true"]',
    );
  }

  connectedCallback() {
    if (this.dataset.autoScroll !== "true") return;

    this.checkOverflow();

    // Re-check on resize
    this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  checkOverflow() {
    if (!this.list) return;

    const containerWidth = this.offsetWidth;
    const contentWidth = this.list.scrollWidth;

    if (contentWidth > containerWidth) {
      this.classList.add("logo-row--scrolling");
      if (this.duplicateList) {
        this.duplicateList.style.display = "flex";
      }
    } else {
      this.classList.remove("logo-row--scrolling");
      if (this.duplicateList) {
        this.duplicateList.style.display = "none";
      }
    }
  }
}

customElements.define("logo-row", LogoRow);
